import { StyledAboutWrapper } from '../About/StyledAbout';

import { ObjectCardset } from '../Cardset';

export const BrokerObjects = ({ data }) => {
  return (
    <StyledAboutWrapper>
      <h2>OBJEKTAI</h2>
      <ObjectCardset data={data} paddingTop={'0px'} />
    </StyledAboutWrapper>
  );
};
